import EQError from "../../../../../utils/EQError";
import * as RawKpiConstants from "../enums/RawKpiConstants";
import * as Bearer from "../converter/enums/BearerEnum";
import Logger from "../../../../../utils/Logger";

export default class KpiValidator {
    /**
     * Constructor
     *
     */
    constructor() {

    }

    /**
     * Display an error and set kpi to NULL value
     *
     * @param rawKpi
     * @param kpiConstant
     */
    static displayErrorAndSetNull(rawKpi, kpiConstant) {
        Logger.log(new EQError("Validator error. Invalid " + kpiConstant + " : " + rawKpi[kpiConstant]));
        rawKpi[kpiConstant] = null;
    }

    /**
     * Validate mcc value
     *
     * @param rawKpi
     */
    mcc(rawKpi) {
        if (rawKpi[RawKpiConstants.MCC]) {
            if (parseInt(rawKpi[RawKpiConstants.MCC]) < 100 || parseInt(rawKpi[RawKpiConstants.MCC]) > 999) {
                KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.MCC);
            }
        }
    }

    /**
     * Validate mnc value
     *
     * @param rawKpi
     */
    mnc(rawKpi) {
        if (rawKpi[RawKpiConstants.MNC]) {
            if (parseInt(rawKpi[RawKpiConstants.MNC]) < 1 || parseInt(rawKpi[RawKpiConstants.MNC]) > 999) {
                KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.MNC);
            }
        }
    }

    /**
     * Validate cell id value
     *
     * @param rawKpi
     */
    cellId(rawKpi) {
        if (rawKpi[RawKpiConstants.CELL_ID]) {
            if ((parseInt(rawKpi[RawKpiConstants.CELL_ID]) < 1 || parseInt(rawKpi[RawKpiConstants.CELL_ID]) > 65535)
                && rawKpi[RawKpiConstants.BEARER].code != Bearer.LTE_A.code && rawKpi[RawKpiConstants.BEARER].code != Bearer.LTE.code && rawKpi[RawKpiConstants.BEARER].code != Bearer.TYPE_4G.code) {
                KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.CELL_ID);
            }
        }
    }

    /**
     * Validate rssi value
     *
     * @param rawKpi
     */
    rssi(rawKpi) {
        if (rawKpi[RawKpiConstants.RSSI]) {
            if (rawKpi[RawKpiConstants.RSSI] < -113 || rawKpi[RawKpiConstants.RSSI] > -51) {
                KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.RSSI);
            }
        }
    }

    /**
     * Validate rscp value
     *
     * @param rawKpi
     */
    rscp(rawKpi) {
        if (rawKpi[RawKpiConstants.RSCP]) {
            if (rawKpi[RawKpiConstants.RSCP] < -113 || rawKpi[RawKpiConstants.RSCP] > -51) {
                KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.RSCP);
            }
        }
    }

    /**
     * Validate rsrp value
     *
     * @param rawKpi
     */
    rsrp(rawKpi) {
        if (rawKpi[RawKpiConstants.RSRP]) {
            if (rawKpi[RawKpiConstants.RSRP] < -140 || rawKpi[RawKpiConstants.RSRP] > -44) {
                KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.RSRP);
            }
        }
    }

    /**
     * Validate psc value
     *
     * @param rawKpi
     */
    psc(rawKpi) {
        if (rawKpi[RawKpiConstants.PSC]) {
            if (rawKpi[RawKpiConstants.PSC] < 0 || rawKpi[RawKpiConstants.PSC] > 512) {
                KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.PSC);
            }
        }
    }

    /**
     * Validate ecno value
     *
     * @param rawKpi
     */
    ecno(rawKpi) {
        if (rawKpi[RawKpiConstants.ECNO]) {
            if (rawKpi[RawKpiConstants.ECNO] < -10 || rawKpi[RawKpiConstants.ECNO] > 0) {
                KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.ECNO);
            }
        }
    }

    /**
     * Validate rsrq value
     *
     * @param rawKpi
     */
    rsrq(rawKpi) {
        if (rawKpi[RawKpiConstants.RSRQ]) {
            if (rawKpi[RawKpiConstants.RSRQ] < -20 || rawKpi[RawKpiConstants.RSRQ] > 3) {
                KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.RSRQ);
            }
        }
    }

    /**
     * Validate snr value
     *
     * @param rawKpi
     */
    snr(rawKpi) {
        if (rawKpi[RawKpiConstants.SNR]) {
            if (rawKpi[RawKpiConstants.SNR] < -20 || rawKpi[RawKpiConstants.SNR] > 30) {
                KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.SNR);
            }
        }
    }

    /**
     * Validate pci value
     *
     * @param rawKpi
     */
    pci(rawKpi) {
        if (rawKpi[RawKpiConstants.PCI]) {
            if (rawKpi[RawKpiConstants.PCI] < 0 || rawKpi[RawKpiConstants.PCI] > 503) {
                KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.PCI);
            }
        }
    }

    /**
     * Validate cellId4g value
     *
     * @param rawKpi
     */
    cellId4g(rawKpi) {
        if (rawKpi[RawKpiConstants.CELL_ID_4G]) {
            if (rawKpi[RawKpiConstants.CELL_ID_4G] < 0 || rawKpi[RawKpiConstants.CELL_ID_4G] > 255) {
                KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.CELL_ID_4G);
            }
        }
    }

    /**
     * Validate the raw kpi object
     *
     * @param rawKpi
     * @returns {Promise}
     */
    validate(rawKpi) {
        const self = this;
        return new Promise((resolve) => {
            const validators = [
                self.mnc,
                self.mcc,
                self.cellId,
                self.rssi,
                self.rscp,
                self.rsrp,
                self.psc,
                self.ecno,
                self.rsrq,
                self.snr,
                self.pci,
                self.cellId4g
            ];

            validators.forEach((cMethod) => {
                cMethod(rawKpi);
            });

            resolve(rawKpi);
        });
    }
}


// WEBPACK FOOTER //
// ./js/core/gateway/service/modules/kpi/validator/KpiValidator.js